import { useState } from "react";
import { EditorState } from "draft-js";
import { addNotes } from "http/fundLync/entityAndAddress.helper";
import { callAdditionalDocument } from "http/fundLync/entityDocuments.helper";
import axios from "axios";
import { API_URL } from "http/url.helper";
import { decryptedValue } from "common/utility";
export const useSubmitNote = (entityId=0, dealId, setToastInfo, setRefetch) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [editorError, setEditorError] = useState("");
  
  const [uploadProgress, setUploadProgress] = useState({});
  const handleEditorChange = (newEditorState) => {
    setEditorState(newEditorState);
    setEditorError("");
  };

  const submitNote = async (values) => {
    const contentState = editorState.getCurrentContent();
    const contentText = contentState.getPlainText();

    if (contentText === "") {
      setEditorError("Note required.");
      return;
    }

    try {
      let newNote = { notes: contentText  };
      if (entityId != 0) {
        newNote["entityId"] = entityId;
      }else{
        newNote["dealId"] = dealId;
      }
      const response = await addNotes(newNote);
      if(values != null){
        const user = decryptedValue(localStorage.getItem("user"));
        const userid = user.id;
        if (!response.data.entityId) {
          return;
        }
        const uploadedUrls = await uploadFile(values);
        await callAdditionalDocument({
          note_id: response.data.id,
          entity_id: response.data.entityId,
          deal_id: dealId, 
          filename: "Notes",
          file_path: uploadedUrls,
          created_by: userid,
        });
      }
      
      if (response.status && response.code === 201) {
        setToastInfo({
          message: response.message,
          showToast: true,
          role: "success",
        });
        
        setRefetch((prev) => !prev);
        setEditorState(EditorState.createEmpty());
      } else {
        setToastInfo({
          message: response.message,
          showToast: true,
          role: "error",
        });
        setRefetch((prev) => !prev);
      }
    } catch (error) {
      console.error("Error submitting note:", error);
    }
  };
  
  const uploadFile = async (files) => {
    const uploadPromises = files.map(
      (file) =>
        new Promise((resolve, reject) => {
          if (file) {
            setUploadProgress((prev) => ({ ...prev, [file.name]: 0 }));
            let formData = new FormData();
            formData.append("upl", file);
            const config = {
              onUploadProgress: (progressEvent) => {
                const percentage = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );

                setUploadProgress((prev) => ({
                  ...prev,
                  [file.name]: percentage,
                }));
              },
            };
            axios
              .post(`${API_URL}/s3/uploadSystemConfigFiles`, formData, config)
              .then((response) => {
                if (response.status === 200) {
                  resolve(response.data[0].fileName);
                } else {
                  reject(response.data.message);
                }
              })
              .catch((error) => {
                reject(error.response?.data?.message || error.message);
              });
          } else {
            reject("File is undefined or null");
          }
        })
    );

    try {
      const uploadedUrls = await Promise.all(uploadPromises);
      return uploadedUrls;
    } catch (error) {
      throw new Error(error);
    }
  };
  return { editorState, handleEditorChange, editorError, submitNote };
};
